"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var ux_assets_1 = require("@lifesize/ux-assets");
var Ruler_1 = __importDefault(require("../Utility/Ruler"));
// increase font size more gradually than the increase in element width (use linear interpolation: y = m*x + b)
var fontSizeMin = 10; // font size for video width = 100
var fontSizeMax = 48; // font size for video width = 800
var fontSizeSlope = (fontSizeMax - fontSizeMin) / (800 - 160);
var fontSizeIntercept = fontSizeMin - (fontSizeSlope * 160);
var VideoMuted = function (props) {
    var _a = react_1.useState(0), eltWidth = _a[0], setEltWidth = _a[1];
    var fontSizeTarget = Math.round(fontSizeSlope * eltWidth + fontSizeIntercept);
    // clamp the fontSize value with js here because Electron discards css font-size if defined with css clamp
    var fontSize = Math.max(fontSizeMin, Math.min(fontSizeTarget, fontSizeMax));
    var className = props.className;
    var dataTestId = props.dataTestId || 'muted-video';
    /*
      keep this style inline as when video is muted after miniPlayer is opened,
      this style will not be copied over to MiniPlayer window for Desktop.
    */
    var style = {
        container: {
            alignItems: 'center',
            backgroundColor: ux_assets_1.colors.lifesizeBlue,
            borderRadius: '5px',
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
            width: '100%'
        },
        placeHolder: __assign({ alignItems: 'center', color: ux_assets_1.colors.white, display: 'flex', flexDirection: 'column', fontSize: fontSize, justifyContent: 'center', maxHeight: '100%', overflow: 'hidden', padding: '0 0.6rem', textAlign: 'center', transition: 'font-size ease 0.2s', width: '100%' }, ux_assets_1.mixins.wrapLongLines)
    };
    // const classes = useStyles({ fontSize, mixins });
    var onResize = react_1.useCallback(function (size) {
        setEltWidth(size.width);
    }, []);
    return (react_1.default.createElement("div", { className: clsx_1.default(className), "data-testid": dataTestId, style: __assign(__assign({}, style.container), props.style) },
        react_1.default.createElement(Ruler_1.default, { onResize: onResize, throttle: 100 }),
        react_1.default.createElement("div", { style: style.placeHolder },
            react_1.default.createElement("span", { "data-testid": "participant-name" }, props.displayName))));
};
exports.default = VideoMuted;
